import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// component
import WrapperEventPage from "../component/WrapperEventPage";

// helpers
import { getJsonFromUrl } from "helpers";

// actions
import * as Actions from "actions";

const mapStateToProps = (state) => ({
  events: state.events,
});

const mapDispatchToProps = (dispatch) => ({
  getEvents: () => dispatch(Actions.getEvents()),
  getEventById: (...args) => dispatch(Actions.getEventById(...args)),
  createEvent: (...args) => dispatch(Actions.createEvent(...args)),
  deleteEvent: (...args) => dispatch(Actions.deleteEvent(...args)),
  updateEvent: (...args) => dispatch(Actions.updateEvent(...args)),
});
class EventPage extends Component {
  static propTypes = {
    session: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,

    events: PropTypes.array,
    getEvents: PropTypes.func,
    getEventById: PropTypes.func,
    createEvent: PropTypes.func,
    deleteEvent: PropTypes.func,
    updateEvent: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    const { location, events } = this.props;

    this.state = {
      urlParams: getJsonFromUrl(location),
      loading: events.length === 0,
    };
  }

  componentDidMount() {
    console.log("componentDidMount");
    this.refresh();
  }

  async refresh() {
    const { getEvents } = this.props;
    await Promise.all([getEvents()]);

    this.setState({ loading: false });
  }

  render() {
    const {
      history,
      events,
      getEventById,
      createEvent,
      deleteEvent,
      updateEvent,
    } = this.props;

    const { urlParams, loading } = this.state;

    return (
      <WrapperEventPage
        history={history}
        refresh={this.refresh.bind(this)}
        loading={loading}
        events={events}
        getEventById={getEventById}
        createEvent={createEvent}
        deleteEvent={deleteEvent}
        updateEvent={updateEvent}
        urlParams={urlParams}
      />
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(EventPage);
